<template>
  <article class="">
    <cabecera></cabecera>
     <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Régimen de Oferta Pública</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <p>COMPAÑÍA MEGA S.A. ingresó al Régimen de Oferta Pública de la Comisión Nacional de Valores (CNV) conforme resolución RESFC-2019-20543-APN-DIR#CNV de fecha 7 de noviembre de 2019.<br>
            A través del <a target="_blank" href="https://www.cnv.gov.ar/SitioWeb/Empresas">sitio web oficial de la CNV</a> (*) podrá consultarse la información relacionada con la sociedad y el mercado de capitales.

            </p>
          <p> <i>(*) El hipervínculo conduce al sitio web de la CNV, ajeno a la Compañía, por lo que Compañía Mega S.A. no puede garantizar la información contenida en el mismo y no se responsabiliza por suplementar, actualizar o corregir dicha información.</i></p>
            
        </div>
      </div>
      
    </section>
    <pie></pie>
  </article>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    margin-top: 30px
    width: 300px
    padding: 5px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5
        color: #fff
a h5
  font-size: 18px
  margin: 0
  display: inline-block
  color: black
  &:hover
    color: #fff
p
  padding-top: 30px
  padding-left: 10px
  padding-right: 10px
  a
    color: #004D9E
i
  font-size: 16px
  opacity: 0.8
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
.caja
  text-align: center
  p
    font-size: 18px

  /* Global Styles */


</style>

<script>
export default {
  name: 'regimen',
  components: {
    Cabecera,
    Pie
  }
}
import $ from 'jquery'
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>





// WEBPACK FOOTER //
// src/components/regimen/regimen.vue